import {
  Card,
  Flex,
  Grid,
  Heading,
  IconPlusCircleOutline,
  mediaBreakpointMixin,
  Page,
  PageContent,
  Spinner,
  Text,
  token,
} from '@zillow/constellation';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { ZTSS_ENTER_YOUR_ADDRESS, ZTSS_ENTER_YOUR_NAME } from '../../../constants/paths';
import Property from './Property';
import useGetProperties from '../../../utils/apis/useGetProperties';
import { Redirect } from 'react-router-dom';
import UnstyledLink from '../../../components/UnstyledLink';

const StyledCard = styled(Card)`
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  &:hover {
    background-color: ${token('colors.blue100')};
  }

  @media ${mediaBreakpointMixin('xxl')} {
    max-width: 350px;
  }
`;

export default function PropertiesPage() {
  const { data: properties = [], isLoading } = useGetProperties({
    select: (response) => response?.data?.response?.listings ?? [],
  });

  if (!isLoading && !properties.length) {
    return <Redirect to={ZTSS_ENTER_YOUR_NAME} />;
  }

  return (
    <Page id="ztss-properties-page">
      <PageContent>
        <Heading
          level={4}
          fontFamily="serif"
          fontType={{ default: 'h5', md: 'h4', lg: 'h3' }}
          fontColor="black"
          marginBottom={{ default: 'sm', md: 'lg' }}
        >
          Select a property to manage applications
        </Heading>
        {isLoading ? (
          <Flex padding="xl" display="flex" justifyContent="center">
            <Spinner size="lg" />
          </Flex>
        ) : (
          <Fragment>
            <UnstyledLink to={ZTSS_ENTER_YOUR_ADDRESS}>
              <StyledCard cardElevation={0} cardType="secondary" marginBottom="md">
                <IconPlusCircleOutline size="sm" fontColor="brand" marginRight="xs" />
                <Text fontColor="brand" fontType="body">
                  Add a new property
                </Text>
              </StyledCard>
            </UnstyledLink>
            <Grid
              display="grid"
              gap="md"
              gridTemplateColumns={{ default: '1fr', lg: 'repeat(2, 1fr)', xxl: 'repeat(3, 1fr)' }}
            >
              {properties.map((property) => (
                <Property key={property.listingAlias} {...property} />
              ))}
            </Grid>
          </Fragment>
        )}
      </PageContent>
    </Page>
  );
}
